<!-- 盘库出入库记录 -->
<template>
  <div class="app-container">
    <Table
      v-show="!showDetail"
      ref="tableRef"
      :showSearchIcon="true"
      :isCreateSearch="false"
      :isSelect="true"
      :data="tableData"
      :columns="columns"
      :total="total"
      :loading="loading"
      rowKey="outInRecordsId"
      :isExpand="true"
      :childColumns="childColumns"
      tableName="checkInventoryOutIn"
      exportDataUrl="/checkInventory/selectOutInRecord"
      :customParamsFun="getCustomParamsFun"
      @expandOpen="handleExpandOpen"
      @onSearch="handleSearch"
    >
      <template #searchBefore>
        <span class="divider">
          <el-checkbox
            v-model="isShowDetail"
            label="显示明细"
            border
            @change="onShowChange"
          />
          <!-- <el-divider
                direction="vertical"
                border-style="solid"
                content-position="center"
            /> -->
        </span>
      </template>
    </Table>
    <Table
      v-show="showDetail"
      ref="tableRefRecord"
      :showSearchIcon="true"
      :data="tableDataRecord"
      :columns="columnsRecord"
      :searchAttrName="searchAttrName"
      :total="totalRecord"
      :loading="loadingRecord"
      rowKey="productRecordsId"
      tableName="warehouseDateRecord"
      :customParamsFun="getCustomParamsFun"
      exportDataUrl="/outInputRecords/selectOutInRecordsDetail"
      @onSearch="handleSearchRecord"
    >
      <template #searchBefore>
        <span class="divider">
          <el-checkbox
            v-model="isShowDetail"
            label="显示明细"
            border
            @change="onShowChange"
          />
          <!-- <el-divider
                direction="vertical"
                border-style="solid"
                content-position="center"
            /> -->
        </span>
      </template>
    </Table>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import { onActivated, ref, onMounted, watch, getCurrentInstance } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import {
  selectProductRecordsByOutInRecordsId,
  selectOutInRecordsDetail,
} from "@/api/warehouse/warehouseDate";
import { selectOutInRecord } from "@/api/checkInventory";
import { isNull } from "@/utils/fangerUtils";
import useApplicationFormStore from "@/store/modules/applicationForm";
import { useRouter } from "vue-router";
import useCacheStore from "@/store/modules/cache";
const cacheStore = useCacheStore();
const { getProductById } = cacheStore;
const router = useRouter();
const applicationFormStore = useApplicationFormStore();
const { proxy } = getCurrentInstance();
const tableRef = ref(null);
const tableRefRecord = ref(null);
const tableData = ref([]);
const total = ref(0);
const loading = ref(false);
const isShowDetail = ref(false);
const searchAttrName = ["outInWarehouseName", "productName", "eqptCode"];
const props = defineProps({
  checkInventoryRecord: {
    // 自定义参数函数
    required: false,
    type: Object,
  },
});
onMounted(() => {
  watch(
    () => props.checkInventoryRecord.checkInventoryRecordId,
    (newVal, oldVal) => {
      tableRef.value.onSearch();
      // proSearch()
    },
    {
      immediate: true,
    }
  );
});
const getCustomParamsFun = () => {
  return {
    checkInventoryRecordId: props.checkInventoryRecord.checkInventoryRecordId,
  };
};
const handleSearch = (data) => {
  loading.value = true;
  selectOutInRecord(data)
    .then((res) => {
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch(() => {})
    .finally(() => {
      loading.value = false;
    });
};
const showDetail = ref(false);
const onShowChange = (val) => {
  showDetail.value = val;
  if (val) {
    proxy.$nextTick(() => {
      tableRefRecord.value.onSearch();
    });
  } else {
    proxy.$nextTick(() => {
      tableRef.value.onSearch();
    });
  }
};
// 查询展开数据
const handleExpandOpen = (row) => {
  if (!isNull(row.childTableData)) return;
  row.childTableLoading = true;
  selectProductRecordsByOutInRecordsId(row.outInRecordsId)
    .then((res) => {
      const childTableData = [];
      res.data.forEach((item) => {
        childTableData.push({
          ...getProductById(item.productId),
          ...item,
        });
      });
      row.childTableData = childTableData;
    })
    .catch(() => {})
    .finally(() => {
      row.childTableLoading = false;
    });
};

onActivated(() => {
  // 修改成功后表格触发重新搜索
  if (applicationFormStore.updateSuccessFlag) {
    applicationFormStore.updateSuccessFlag = false;
    tableRef.value && tableRef.value.onSearch();
  }
});

const columns = getCustomTableCols([
  "name",
  "contractNo",
  "outInType",
  "outInWarehouseStatus",
  "outWarehouse",
  "inWarehouse",
  "operatorName",
  "operateTime",
]);
const goDetail = (event, row) => {
  applicationFormStore.updateData = row;
  router.push({
    path: "/outInRecords/warehouseProRecord",
    query: { proId: row.productRecordsId },
  });
};
const childColumns = getCustomTableCols([
  "productName",
  "productNum",
  "productType",
  "supplierp",
  "supplierModel",
  "internalModel",
  "usageType",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "明细",
        controlType: "success",
        controlText: true,
        controlFun: goDetail,
      },
    ],
  },
]);
const tableDataRecord = ref([]);
const totalRecord = ref(0);
const loadingRecord = ref(false);
const handleSearchRecord = (data) => {
  loadingRecord.value = true;
  selectOutInRecordsDetail({
    ...data,
  })
    .then((res) => {
      tableDataRecord.value = res.data;
      totalRecord.value = res?.pageParam?.totleInfo
        ? res.pageParam.totleInfo
        : 0;
    })
    .catch((res) => {})
    .finally(() => {
      loadingRecord.value = false;
    });
};

const columnsRecord = getCustomTableCols([
  "outInWarehouseName",
  "outInWarehouseStatus",
  "outInType",
  "outWarehouse",
  "inWarehouse",
  "trackingNumber",
  "returnAddress",
  "recipient",
  "productName",
  "eqptCode",
  "productType",
  "supplier",
  "supplierModel",
  "internalModel",
  "usageType",
  "productNum",
  "completeNum",
  "incompleteNum",
  "operateTime",
  "operatorName",
]);
</script>

<style lang="scss" scoped>
.app-container {
  .divider {
    margin-right: 12px;
    // :deep(.el-divider) {
    //     height: 32px;
    //     margin-right: 8px;
    // }
  }
}
</style>
